import React, { useEffect, useState } from "react";
import MapPin from "../../../../icons/MapPin";
import { useRouter } from "next/router";
import WrapperPropertiesCard from "./cards/WrapperPropertiesCard";
import { DateTime } from "luxon";
import { useSelector } from "react-redux";
import Pusher from "pusher-js";
import {
  getAllBids,
  getAllWrongBids,
  getAuctionEventByUuid,
  getLatestBid,
  getLatestBidOfUser,
  useCountdownV2,
} from "services";
import AuctionParticipationTncModel from "../auctionEvents/AuctionParticipationTncModel";
interface LiveEventsContainerProps {
  eventData: any;
}

export default function LiveEventsContainer({
  eventData,
}: LiveEventsContainerProps) {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [eventId, setEventId] = useState("");
  const [eventStatus, setEventStatus] = useState("");

  const accessToken = useSelector((state: any) => state.bidderAuth.accessToken);
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const userNameFromOnboarding = useSelector((state: any) => {
    return state.bidderAuth?.onboarding?.name;
  });

  const [endTime, setEndTime] = useState<any>(0);
  const [timeOffset, setTimeOffset] = useState(0);
  const [serverTime, setServerTime] = useState(0);
  const [status, setStatus] = useState("");
  const [isKycVerified, setIsKycVerified] = useState(false);
  const [currentTime, setCurrentTime] = useState<any>(0);
  const [startTime, setStartTime] = useState(0);

  const init = async (uuid: any) => {
    try {
      const data: any = await getAuctionEventByUuid(uuid);
      if (data) {
        setServerTime(data.server_time);
        const allBid: any = await getAllBids(data.uuid);
        const allWrongBids: any = await getAllWrongBids(data.uuid, user.uuid);
        const currentUserLastBid: any = await getLatestBidOfUser(
          data.uuid,
          user.uuid,
        );
        // setCurrentUserLatestBid(currentUserLastBid);
        if (allBid) {
          // setBidsEvent(allBid);
          if (allBid.length >= 2) {
            // setPrevBid(allBid[allBid.length - 2]);
          }
        }
        if (allWrongBids) {
          // setWrongBidsEvent(allWrongBids);
        }
        const lastBid: any = await getLatestBid(data.uuid);
        // setLatestBid(lastBid);
        // setReservePrice(data.reserve_price);
        setStatus(data?.status);
        const start_timestamp = DateTime.fromISO(data.start_date_time)
          .setZone("Asia/Kolkata")
          .toMillis();
        setStartTime(start_timestamp);

        if (lastBid) {
          setEndTime(parseInt(lastBid.final_end_time));
        } else {
          setEndTime(parseInt(data.final_end_date));
        }
      }
    } catch (err) {
      console.log("error in init::>", err);
      // setLoading(false);
      router.reload();
    }
  };

  useEffect(() => {
    if (eventData) {
      if (eventData?.bidders?.length > 0) {
        const isKycVerified =
          eventData?.bidders?.find((b: any) => b.user_uuid === user.uuid)
            ?.status === "verified";
        setIsKycVerified(!!isKycVerified);
      }
      init(eventData?.uuid);
    }
  }, [eventData]);

  const getBidderName = (eventData: any, userUuid: string): any => {
    try {
      if (
        !eventData ||
        !eventData.bidders ||
        !Array.isArray(eventData.bidders)
      ) {
        return null;
      }
      const currentUserBidder = eventData.bidders.find(
        (bidder: any) => bidder && bidder.user_uuid === userUuid,
      );
      if (currentUserBidder) {
        const bidderName = currentUserBidder.meta?.name;
        return bidderName;
      }
      return null;
    } catch (error) {
      console.warn("Error extracting bidder name:", error);
      return null;
    }
  };
  useEffect(() => {
    // Pusher.logToConsole = false;
    let authConfig = {};
    let channelId = `auction-event-${eventData.uuid}`;
    if (process.env.NEXT_PUBLIC_ENABLE_BIDDER_ACTIVITY === "true") {
      const bidderName = getBidderName(eventData, user?.uuid);
      authConfig = {
        authEndpoint: `${process.env.NEXT_PUBLIC_API_URL}/auction/pusher/auth`,
        auth: {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            event_uuid: eventData.uuid,
            user_type: "bidder",
            user_name: bidderName,
          },
        },
      };
      channelId = `presence-${channelId}`;
    }

    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
      ...authConfig,
    });

    console.log("channelId: ", channelId);
    const channel = pusher.subscribe(channelId);

    channel.bind("bidding_value_has_been_changed", (data: any) => {
      init(eventData?.uuid);
      // handleDataChange(data);
      // setBidsEvent((prev) => [...prev, data]);
      // setBidsEvent([...bidsEvent, data]);
    });

    channel.bind("user_placed_wrong_bid", (data: any) => {
      if (data.user_uuid === user.uuid) {
        setServerTime(data.server_time);
        init(eventData?.uuid);
        // setWrongBidsEvent((prev) => [...prev, data]);
        // setFailedNotification(null);
        // setShowFailedNotification(false);
        // setShowSuccessNotification(false);
        // setFailedNotification(data.reason);
        // setShowFailedNotification(true);
        (async () => {
          // await checkBidStatus();
        })();
      }
    });

    channel.bind("auction_event_has_started", (data: any) => {
      if (data) {
        init(eventData?.uuid);
        setServerTime(data.server_time);
        setStatus("live");
      }
    });

    channel.bind("auction_event_has_ended", (data: any) => {
      console.log("auction_event_has_ended----", data);
      if (data) {
        setStatus("end");
        init(eventData?.uuid);
        // handleBidsResult();
      }
    });
    // test it
    channel.bind("auction_event_has_cancelled", (data: any) => {
      console.log("auction_event_has_cancelled----", data);

      if (data) {
        setStatus("end");
        // setOpenCancelledEventModal(data);
      }
    });

    pusher.connection.bind("error", function (err: any) {
      console.log("PUSHER ERROR:::>", err);
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        console.log(">>> CLOSED ABNORMALLY");
        // Websocket: CLOSED ABNORMALLY
        // get the data and refresh the page if fails
        init(eventData.uuid);
      }
    });

    // pusher.connection.bind("disconnected", function (err: any) {
    //   console.log(">>> disconnected");
    //   setConnectionStatus("Offline");
    // });

    // pusher.connection.bind("connected", function (err: any) {
    //   console.log("connected", pusher.sessionID);
    //   setConnectionStatus("Online");
    // });

    // pusher.connection.bind("state_change", (states: any) => {
    //   const { current, previous } = states;
    //   console.log(`current state: ${current}, previous state: ${previous}`);
    //   switch (current) {
    //     case "failed":
    //       setConnectionStatus("Offline");
    //       break;
    //     case "disconnected":
    //       setConnectionStatus("Offline");
    //       break;
    //     case "unavailable":
    //       setConnectionStatus("Offline");
    //       break;
    //     case "connected":
    //       setConnectionStatus("Online");
    //       break;
    //     case "connecting":
    //       setConnectionStatus("Connecting"); // Connecting
    //       break;
    //     default:
    //       break;
    //   }
    // });

    return function cleanup() {
      pusher.disconnect();
    };
  }, [eventData.uuid]);

  useEffect(() => {
    if (serverTime) {
      const serverDateTime =
        DateTime.fromMillis(serverTime).setZone("Asia/Kolkata");
      const localDateTime = DateTime.now().setZone("Asia/Kolkata");
      const offset = serverDateTime.toMillis() - localDateTime.toMillis();
      setTimeOffset(offset);
    }
  }, [serverTime]);

  useEffect(() => {
    console.log("Update time");
    const intervalId = setInterval(() => {
      setCurrentTime(
        DateTime.now()
          .plus({ milliseconds: timeOffset })
          .setZone("Asia/Kolkata")
          .toFormat("DDD hh:mm:ss a"),
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeOffset]);

  const [hours, minutes, seconds, isTimeEnded] = useCountdownV2(
    endTime,
    timeOffset,
  );
  const calculateProgress = (): number => {
    const serverTime = DateTime.fromFormat(
      String(currentTime),
      "d MMMM yyyy hh:mm:ss a",
      {
        zone: "Asia/Kolkata",
      },
    ).toMillis();
    if (startTime >= serverTime) return 0;
    if (serverTime >= endTime) return 100;

    const elapsed = serverTime - startTime;
    const totalDuration = endTime - startTime;
    return Math.min((elapsed / totalDuration) * 100, 100);
  };

  useEffect(() => {
    setIsOpen(false);
    setEventId("");
    setEventStatus("");
  }, [isTimeEnded]);

  const onAgreeAndContinue = async (eventId: string, eventStatus: string) => {
    console.log("onAgreeAndContinue");
    if (!eventId) {
      console.error("Invalid event ID or status", eventId, eventStatus);
      return;
    }
    window.open(`/auction-events/${eventId}`, "_blank");
    setIsOpen(false);
    setEventId("");
    setEventStatus("");
  };

  return (
    <div>
      <WrapperPropertiesCard
        status={status}
        cardType="auction"
        showTag={true}
        tagText="LIVE AUCTION"
        showId={true}
        id={eventData?.listing_id}
        imgLink="https://auction-bazaar-production.imgix.net/d641c24c-d728-43c8-ba0f-9e1e30133f06"
        headingText={`${eventData?.property_dump?.asset?.name} ${eventData?.property_dump?.sub_asset_type?.name} `}
        subHeadingText={`${eventData?.property_dump?.city?.name}, ${eventData?.property_dump?.state?.name}`}
        showCTA={true}
        ctaText="Start Bidding"
        ctaSubText={isKycVerified ? false : "KYC Pending"}
        onclickHandler={() => {
          if (isTimeEnded === 0) {
            setIsOpen(true);
            setEventId(eventData.uuid);
            setEventStatus(status);
          } else {
            setIsOpen(false);
            setEventId("");
            setEventStatus("");
            // window.open(`/auction-events/${eventData.uuid}`, "_blank");
          }
        }}
        isDisabled={isTimeEnded === 1 || !isKycVerified}
        progressValue={calculateProgress()}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
        subHeadingIcon={<MapPin />}
        styles={{
          tagStyle: "bg-[#FFF3F3] text-[#B60100]",
          CTAStyle: "bg-black text-white font-sans",
          imgStyle:
            "w-full object-cover max-h-[260px] h-[180px] xl:h-[240px] min-w-[200px] xl:min-w-[260px]",
        }}
      />
      <AuctionParticipationTncModel
        onAgreeAndContinue={onAgreeAndContinue}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        eventId={eventId}
        eventStatus={eventStatus}
      />
    </div>
  );
}
